export interface CognitoUser {
  firstname: string;
  lastname: string;
  email: string;
}
